import React, { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup';
import InputField from '../components/InputField/InputField'

import './styles/Login.scss'
import { schema } from '../schema/schema';
import { useForm } from 'react-hook-form';
import { ILoginInputs } from '../types/types';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/auth.hook';
import { useAppSelector } from '../redux/hooks';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import Button from '../components/Button/Button';

const Login = () => {
  const {login} = useAuth()
  let navigation = useNavigate()
  let auth = useAppSelector((state) => state.authReducer)

  const { register, handleSubmit, formState:{ errors } } = useForm<ILoginInputs>({
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    if(!!auth.user) navigation('/')
  }, [auth, navigation])

  return (
    <main>
      <Breadcrumbs/>
      <section>
        <div className="login">
          <div className="container">
            <h1>Customer Login</h1>
            <div className="login-wrapper">
              <div className="login-account">
                <h2>Registred Customers</h2>
                <p>If you have an account, sign in with your email address.</p>
                <form onSubmit={handleSubmit(login)}>
                  <InputField label='Login' required type='email' {...register('email')}/>
                  <InputField label='Password' required type='password' {...register('password')}/>
                  <div className="button-container-form">
                    <Button type='submit' variant='filled' action={() => {console.log(errors)}}>Submit data</Button>
                  </div>
                </form>
              </div>
              <div className="login-register">
                <h2>New Customer?</h2>
                <p>Creating an account has many benefits:</p>
                <ul>
                  <li>Check out faster</li>
                  <li>Keep more than one address</li>
                  <li>Track orders and more</li>
                </ul>
                <div className="button-container">
                  <Button variant='filled' action={() => navigation('/register')}>Create an account</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Login